// src/data/drivers.js
// Single source of truth for your drivers (named + default export)

// Default list of drivers. You can modify this list from the Settings
// page; changes will be persisted to localStorage under the key
// "ci_drivers". Each driver has an id, name, vehicle description and
// type. The id values are arbitrary and should be unique.
// Each driver may optionally define a `payRate` property representing the
// fraction of the job total they earn. For example a payRate of 0.36 means
// the driver earns 36% of the ticket price. You can adjust these values
// from the Business Settings page or modify them here. If omitted the
// application will assume a zero pay rate for that driver.
const DEFAULT_DRIVERS = [
  { id: "sh", name: "Shaun Matthews",    vehicle: "SUV #4",  type: "SUV", payRate: 0.39 },
  { id: "jb", name: "John Billings", vehicle: "Van #3",  type: "Van", payRate: 0.39 },
  { id: "sm", name: "Shaun Matthews", vehicle: "Van #1",  type: "Van", payRate: 0.39 },
  { id: "tb", name: "Tyler Benine",      vehicle: "Van #2",  type: "Van", payRate: 0.39 },
];

/**
 * Retrieve the current driver roster from localStorage. When a
 * custom list has been saved it is returned; otherwise the
 * DEFAULT_DRIVERS are used. If called outside of the browser (for
 * example during server‑side rendering) the defaults will be
 * returned.
 */
export function getDrivers() {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      const raw = window.localStorage.getItem("ci_drivers");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      }
    } catch (e) {
      // ignore parse errors and fall back to defaults
    }
  }
  return [...DEFAULT_DRIVERS];
}

/**
 * Persist a driver roster to localStorage. Passing any array of
 * drivers will replace the saved list. Only call this from
 * client‑side code (e.g. Settings page).
 */
export function saveDrivers(list) {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      window.localStorage.setItem("ci_drivers", JSON.stringify(list || []));
    } catch (e) {
      // localStorage may be unavailable; ignore
    }
  }
}

// Lookup a driver by id. Uses getDrivers() so it sees any changes
// saved by the user.
export function driverById(id) {
  return getDrivers().find((d) => d.id === id) || null;
}

// Build select options for a driver picker. Uses getDrivers() so it
// always reflects the current roster. Each option has a value of the
// driver id and a label combining the name, vehicle and type.
export function driverOptions() {
  return getDrivers().map((d) => ({
    value: d.id,
    label: `${d.name} — ${d.vehicle} (${d.type})`,
  }));
}

// Export current roster as a constant for backward compatibility. Note
// that this snapshot will not update when drivers are added or
// removed after the module is imported; prefer calling getDrivers().
export const DRIVERS = getDrivers();

export default DRIVERS;






